import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import cn from 'classnames';
var STYLES_ACTIVE = {
  color: 'green.darkest',
  background: 'green.transparent'
};
var STYLES_WARNING = {
  color: 'red.darkest',
  background: 'red.transparent'
};
var STYLES_INFO = {
  color: 'blue.darkest',
  background: 'blue.light'
};
function Label(_ref) {
  var className = _ref.className,
    children = _ref.children,
    variant = _ref.variant,
    icon = _ref.icon;
  return jsx("span", {
    className: cn('zenit', className),
    sx: _objectSpread(_objectSpread(_objectSpread({
      display: 'inline-flex',
      alignItems: 'center',
      padding: '1px 6px',
      color: 'grey.9',
      background: 'grey.3',
      borderRadius: '8px',
      // supported on firefox, safari
      // chrome, IE round to 1px
      fontSize: 1,
      fontWeight: 'normal',
      lineHeight: 1
    }, variant === 'active' && STYLES_ACTIVE), variant === 'warning' && STYLES_WARNING), variant === 'info' && STYLES_INFO)
  }, icon && jsx("span", {
    sx: {
      display: 'inline-flex',
      mr: 1
    }
  }, icon), children);
}
export { Label };